import script from "./FoodDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodDetail.vue?vue&type=script&setup=true&lang=js"

import "./FoodDetail.vue?vue&type=style&index=0&id=57622e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57622e84"]])

export default __exports__